const DEFAULT_SIZE = 28

const pickLabel = (sourceEl, fallback = '') => {
  if (!sourceEl) return fallback
  const dt = sourceEl.getAttribute?.('data-tooltip')
  if (dt && dt.trim()) return dt.trim()
  const title = sourceEl.getAttribute?.('title')
  if (title && title.trim()) return title.trim()
  return fallback
}

const firstGlyph = (s) => {
  const t = `${s || ''}`.trim()
  if (!t) return ''
  return t.slice(0, 1).toUpperCase()
}

const hasUrlBg = (bg) => typeof bg === 'string' && bg.includes('url(')

export const setTinyDragPreview = (e, sourceEl, opts = {}) => {
  if (!e || !e.dataTransfer) return
  if (typeof document === 'undefined' || !document.body) return

  const size = Number.isFinite(opts.size) ? opts.size : DEFAULT_SIZE
  const label = pickLabel(sourceEl, opts.label || '')

  const preview = document.createElement('div')
  preview.style.position = 'fixed'
  preview.style.left = '-10000px'
  preview.style.top = '-10000px'
  preview.style.width = `${size}px`
  preview.style.height = `${size}px`
  preview.style.borderRadius = '8px'
  preview.style.overflow = 'hidden'
  preview.style.display = 'flex'
  preview.style.alignItems = 'center'
  preview.style.justifyContent = 'center'
  preview.style.boxShadow = '0 10px 28px rgba(0, 0, 0, 0.55)'
  preview.style.border = '1px solid rgba(255, 255, 255, 0.18)'
  preview.style.background = 'rgba(0, 0, 0, 0.25)'
  preview.style.backdropFilter = 'blur(18px)'
  preview.style.pointerEvents = 'none'
  preview.style.userSelect = 'none'

  let attached = false
  try {
    document.body.appendChild(preview)
    attached = true
  } catch (err) {
    attached = false
  }

  // Prefer actual image content from the dragged element
  const imgEl = sourceEl?.querySelector?.('img')
  if (imgEl && imgEl.src) {
    const img = document.createElement('img')
    img.src = imgEl.src
    img.alt = ''
    img.draggable = false
    img.style.width = '100%'
    img.style.height = '100%'
    img.style.objectFit = 'cover'
    img.style.pointerEvents = 'none'
    preview.appendChild(img)
  } else {
    // Fall back to background image/color of the element
    const cs = sourceEl ? window.getComputedStyle(sourceEl) : null
    const bgImg = cs?.backgroundImage
    const bgColor = cs?.backgroundColor
    if (hasUrlBg(bgImg)) {
      preview.style.backgroundImage = bgImg
      preview.style.backgroundSize = 'cover'
      preview.style.backgroundPosition = 'center center'
      preview.style.backgroundRepeat = 'no-repeat'
    } else if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') {
      preview.style.background = bgColor
    }

    const glyph = firstGlyph(label)
    if (glyph) {
      const span = document.createElement('span')
      span.textContent = glyph
      span.style.fontSize = '12px'
      span.style.fontWeight = '700'
      span.style.color = 'rgba(255, 255, 255, 0.92)'
      span.style.textShadow = '0 0 10px rgba(0, 0, 0, 0.55)'
      preview.appendChild(span)
    }
  }

  const ox = Number.isFinite(opts.offsetX) ? opts.offsetX : Math.round(size / 2)
  const oy = Number.isFinite(opts.offsetY) ? opts.offsetY : Math.round(size / 2)
  e.dataTransfer.setDragImage(preview, ox, oy)

  // Remove the helper node on next tick; the drag image is snapshotted at dragstart.
  if (attached) {
    setTimeout(() => {
      if (preview && preview.parentNode) preview.parentNode.removeChild(preview)
    }, 0)
  }
}


